import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import authReducer from './slices/authSlice'
import filterReducer from './slices/filterSlice'
import listingReducer from './slices/listingSlice'
import reviewReducer from './slices/reviewSlice'
import likesReducer from './slices/likeSlice'
import cartReducer from './slices/cartSlice'
import addressReducer from './slices/addressSlice'
import locationReducer from './slices/locationSlice'
import chatReducer from './slices/chatSlice'
import currencyReducer from './slices/currencySlice'
import shippingReducer from './slices/deliverySlice'
import paymentReducer from './slices/paymentSlice'
import productReducer from './slices/productSlice'
import orderReducer from './slices/orderSlice'
import userReducer from './slices/userSlice'
import checkoutReducer from './slices/checkoutSlice'
import offerReducer from './slices/offerSlice'
import requestReducer from './slices/requestSlice'
import fulfillmentGroupReducer from './slices/fulfillmentGroupSlice'

import {
  enhancedAuthApi,
  enhancedProductApi,
  enhancedListingApi,
  enhancedReviewApi,
  enhancedProfileApi,
  enhancedAddressApi,
  enhancedCartApi,
  userApi,
  offerApi,
  requestApi
} from './apis'

import { messageApi } from './apis/endpoints/messageApi'
import { enhancedDeliveryApi } from './apis/endpoints/deliveryApi'
import { paymentApi } from './apis/endpoints/paymentApi'
import { enhancedOrderApi } from './apis/endpoints/orderApi'
import { fulfillmentGroupApi } from './apis/endpoints/fulfillmentGroupApi'
import { orderItemApi } from './apis/endpoints/orderItemApi'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    filter: filterReducer,
    listing: listingReducer,
    review: reviewReducer,
    likes: likesReducer,
    cart: cartReducer,
    address: addressReducer,
    location: locationReducer,
    chat: chatReducer,
    currency: currencyReducer,
    shipping: shippingReducer,
    payment: paymentReducer,
    product: productReducer,
    order: orderReducer,
    user: userReducer,
    checkout: checkoutReducer,
    offer: offerReducer,
    request: requestReducer,
    fulfillmentGroup: fulfillmentGroupReducer,
    [enhancedAuthApi.reducerPath]: enhancedAuthApi.reducer,
    [enhancedProductApi.reducerPath]: enhancedProductApi.reducer,
    [enhancedListingApi.reducerPath]: enhancedListingApi.reducer,
    [enhancedReviewApi.reducerPath]: enhancedReviewApi.reducer,
    [enhancedProfileApi.reducerPath]: enhancedProfileApi.reducer,
    [enhancedAddressApi.reducerPath]: enhancedAddressApi.reducer,
    [enhancedCartApi.reducerPath]: enhancedCartApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [enhancedDeliveryApi.reducerPath]: enhancedDeliveryApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [enhancedOrderApi.reducerPath]: enhancedOrderApi.reducer,
    [offerApi.reducerPath]: offerApi.reducer,
    [requestApi.reducerPath]: requestApi.reducer,
    [fulfillmentGroupApi.reducerPath]: fulfillmentGroupApi.reducer,
    [orderItemApi.reducerPath]: orderItemApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(
      enhancedAuthApi.middleware,
      enhancedProductApi.middleware,
      enhancedListingApi.middleware,
      enhancedReviewApi.middleware,
      enhancedProfileApi.middleware,
      enhancedAddressApi.middleware,
      enhancedCartApi.middleware,
      messageApi.middleware,
      userApi.middleware,
      enhancedDeliveryApi.middleware,
      paymentApi.middleware,
      enhancedOrderApi.middleware,
      offerApi.middleware,
      requestApi.middleware,
      fulfillmentGroupApi.middleware,
      orderItemApi.middleware
    ),
  devTools: process.env.NODE_ENV !== 'production',
})

setupListeners(store.dispatch)

export default store